// Helper extracted from main.ts to keep that file under §10's 400-line cap.
//
// Returns the closest active (non-depleted) resource node within
// balance.gathering.maxRangePx, or null if none is in range.

import { balance } from "./types.ts";
import type { ResourceNode } from "./types.ts";

export function nearestGatherableNode(
  nodes: Map<string, ResourceNode>,
  playerX: number,
  playerY: number,
): ResourceNode | null {
  let nearest: ResourceNode | null = null;
  // Explicit number: balance values are literal-narrowed by `as const`;
  // this field must accept the computed `dist` float on reassignment.
  let nearestDist: number = balance.gathering.maxRangePx;
  for (const node of nodes.values()) {
    if (node.respawnAt !== null) continue;
    const dx = playerX - node.x;
    const dy = playerY - node.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist <= nearestDist) {
      nearest = node;
      nearestDist = dist;
    }
  }
  return nearest;
}
